/**  Assistant Event Service */
class AssistantEventService {
  constructor(
    assistantDomain,
    authenticationExpireHandler,
    authErrorHandler,
    navigationHandler,
    authenticationSuccessHandler,
    errorLogger
  ) {
    this.assistantDomain = assistantDomain;
    this.authenticationExpireHandler = authenticationExpireHandler;
    this.authErrorHandler = authErrorHandler;
    this.navigationHandler = navigationHandler;
    this.authenticationSuccessHandler = authenticationSuccessHandler;
    this.assistantContentWindow = null;
    this.errorLogger = errorLogger;
    this.handler = this.handler.bind(this);
  }

  incomingEvents = {
    AUTH_SUCCESS: "MDXWatsonAuthenticationSuccess",
    SESSION_EXPIRED: "MDXWatsonSessionExpired",
    NAVIGATE: "MDXWatsonExternalNavigate",
    ERROR: "MDXWatsonError"
  };

  outgoingEvents = {
    LAUNCH_TOOL: "MDXWatsonNavigateTool"
  };

  //TODO: "input" will be removed after chatbot is removed from assistant
  validEventParams = ["navType", "input", "drugId", "drugName"];

  handler = (event) => {
    if (!this.assistantDomain.startsWith(event.origin)) {
      return;
    }
    const data =
      typeof event.data === "object" ? event.data : JSON.parse(event.data);

    const { name } = data;
    switch (name) {
      case this.incomingEvents.SESSION_EXPIRED:
        this.authenticationExpireHandler();
        break;
      case this.incomingEvents.AUTH_SUCCESS:
        this.assistantContentWindow = event.source;
        this.authenticationSuccessHandler();
        break;
      case this.incomingEvents.NAVIGATE:
        this.navigationHandler(data);
        break;
      case this.incomingEvents.ERROR:
        this.errorHandler(data);
        break;
      default:
        this.errorHandler(data);
        break;
    }
  };

  listenEvent = () => {
    window.addEventListener("message", this.handler);
  };

  unlistenEvent = () => {
    window.removeEventListener("message", this.handler);
  };

  broadcastNavToolEvent = (broadCast) => {
    const filteredParams = Object.fromEntries(
      Object.entries(broadCast ?? {}).filter(([key]) =>
        this.validEventParams.includes(key)
      )
    );
    if (this.assistantContentWindow) {
      this.assistantContentWindow.postMessage(
        {
          name: this.outgoingEvents.LAUNCH_TOOL,
          type: this.outgoingEvents.LAUNCH_TOOL,
          ...filteredParams
        },
        this.assistantDomain
      );
    }
  };

  errorHandler = (data) => {
    const { name, errorType, message } = data || {};

    if (!name && !errorType && !message) {
      // Don't do anything if the event was noise with no data
      return;
    }

    switch (errorType) {
      case "authentication":
        this.authErrorHandler();
        return;
      default:
        break;
    }

    this.errorLogger(
      new Error(
        `Unknown event: '${name}' event from Assistant with a errorType of ${
          errorType ?? "noTypeProvided"
        } with a message of ${message ?? "noMessageProvided"}.`
      )
    );
  };
}

export default AssistantEventService;
